export enum BoardType {
    USER_BISK = 'USER_BISK', // BISK
    USER_INFO = 'USER_INFO', // Users with points (like Turf Wars)
    USER_RANK = 'USER_RANK', // User Ranking for events that don't have bisk
    IDX_INFO = 'IDX_INFO' // IDX INFO - Stats or West Coast/East Coast 
}